import { useVuexStore } from '@superbet-group/web.lib.vue-utilities';

import { BetBuilderAnalyticsStore } from '../analytics';

// Handy composeable to make it possible to use the store with less noise from code
export function useAnalytics() {
    const store = useVuexStore<BetBuilderAnalyticsStore>('data/betBuilder/analytics');

    return {
        betBuilderEventCardLabelClicked: store.action('betBuilderEventCardLabelClicked'),
        betBuilderOboardingBuildNowClicked: store.action('betBuilderOboardingBuildNowClicked'),
        betBuilderCrossSellingFromSuperbetsBannerClicked: store.action('betBuilderCrossSellingFromSuperbetsBannerClicked'),
        betBuilderInfoBannerClicked: store.action('betBuilderInfoBannerClicked'),
        betBuilderInfoBannerClosed: store.action('betBuilderInfoBannerClosed'),
        marketInfoClicked: store.action('marketInfoClicked'),
        marketFavouriteClicked: store.action('marketFavouriteClicked'),
        marketToggled: store.action('marketToggled'),
        legAdded: store.action('legAdded'),
        legRemoved: store.action('legRemoved'),
        uncombinableOddTapped: store.action('uncombinableOddTapped'),
        summaryCleared: store.action('summaryCleared'),
        unavailableOddsRemoved: store.action('unavailableOddsRemoved'),
        superbetsCardClicked: store.action('superbetsCardClicked'),
        addSuperbetToBetslip: store.action('addSuperbetToBetslip'),
        addToBetslip: store.action('addToBetslip'),
        addToBetslipSucceeded: store.action('addToBetslipSucceeded'),
        addToBetslipFailed: store.action('addToBetslipFailed'),
        betslipEventRemoved: store.action('betslipEventRemoved'),
        conflictOccurred: store.action('conflictOccurred'),
        conflictReplaced: store.action('conflictReplaced'),
        conflictCancelled: store.action('conflictCancelled'),
        tutorialPageTriggered: store.action('tutorialPageTriggered'),
    };
}
